export {default as AwardPointsModalContainer} from './AwardPointsModal/AwardPointsModalContainer';
export {default as AwardSpinsModalContainer} from './AwardSpinsModal/AwardSpinsModalContainer';
export {default as AwardDaysModalContainer} from './AwardDaysModal/AwardDaysModalContainer';
export {default as ChangeEmailModalContainer} from './ChangeEmailModal/ChangeEmailModalContainer';
export {default as ChangePasswordModalContainer} from './ChangePasswordModal/ChangePasswordModalContainer';
export {default as RepairProfileModalContainer} from './RepairProfileModal/RepairProfileModalContainer';
export {default as DeleteUserModalContainer} from './DeleteUserModal/DeleteUserModalContainer';
export {default as ConfirmDeleteUserDataModal} from './ConfirmDeleteUserDataModal';
export {default as RevokePointsModalContainer} from './RevokePointsModal/RevokePointsModalContainer';
export {default as RevokeAmountOfPointsModalContainer} from './RevokeAmountOfPointsModal/RevokeAmountOfPointsModalContainer';



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/index.js